import * as React from "react";

import {Item} from "shared/controls/Tabs/Item";
import {Accordion} from "shared/controls/Accordion/Accordion";
import {AccordionItem} from "shared/controls/Accordion/AccordionItem";
import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";
import {GroupProperties} from "InternalShared/PageBuilder/Controls/Properties/styles/GroupProperties";
import {EventManager} from "shared/utilities/Events/EventManager";
import {UpdateFieldSettingsPanel} from "InternalShared/Events/UpdateFieldSettingsPanel";
import {UpdateStyleSettingsPanel} from "InternalShared/Events/UpdateStyleSettingsPanel";

export class StylesTab extends React.Component<FieldsTabProps, FieldsTabState> {
    static defaultProps: Partial<FieldsTabProps> = {};

    constructor(props: FieldsTabProps) {
        super(props);
        this.state = {
            Item:null,
            Properties:[]
        };
        this.Update=this.Update.bind(this);
        EventManager.Subscribe(UpdateStyleSettingsPanel,this.Update);
    }


    public Update(){
        this.setState({
            Properties:this.state.Item?this.state.Item.GetStyles():[]
        });
    }

    public render() {
        return (
            <Accordion OpenOnlyOne={false}>
                {
                    this.state.Properties.map(group=>
                        <AccordionItem key={group.Label} Title={group.Label} IsOpen={true}>

                            {group.Properties.map((property,index)=>
                                property.renderer(index.toString())
                            )}

                        </AccordionItem>
                    )
                }

            </Accordion>
        )
    }

    public FillPanel(Item: PDFControlBase):Promise<void> {
        return new Promise(resolve => {
            this.setState({
                Properties:Item?Item.GetStyles():[],
                Item:Item
            },resolve);
        })
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FieldsTabProps {

}

interface FieldsTabState {
    Item:PDFControlBase;
    Properties:GroupProperties[];
}

//#endregion "My Region"